var _rect, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanToProduce(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-plan-to-produce"
  }, "Plan-to-Produce") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-plan-to-produce"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 9,
    height: 9,
    rx: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8h9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4v2.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4v2.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 11,
    r: 0.6,
    fill: "currentColor",
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 11,
    r: 0.6,
    fill: "currentColor",
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20v-8l3 2v-2l3 2v-2l3 2v6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20v-3h2v3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20v-3h2v3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanToProduce);
export default __webpack_public_path__ + "static/media/plan-to-produce.06d06819dff1cb9ea861f89d74f9e5e6.svg";
export { ForwardRef as ReactComponent };